import LandingComponent from "../components/landing";
import BodyComponent from "../components/body";

export const LandingSection = {
  key: "component--landing",
  component: LandingComponent,
};

export const BodySection = {
  key: "component--body",
  component: BodyComponent,
};

export const DatoKeyValuesMap = [LandingSection, BodySection];
